import s from "./settings-nav.module.scss";
import classNames from "classnames";

export const SettingsNav = ({ activeSection, links, onNavigate }) => (
	<nav className={s.sectionNav}>
		{links.map((section) => (
			<button
				key={section.id}
				type="button"
				className={classNames(s.sectionNavItem, activeSection === section.id && s.active)}
				onClick={() => onNavigate(section)}
			>
				{section.label}
			</button>
		))}
	</nav>
);
